import React from 'react';
import { Tab, Tabs } from '../../../../../components/common/TabCustom';
import CondicionesEspecialesGrid from '../../../../../components/controls/CondicionesEspecialesGrid';
import CuentaCertificadoApremioGrid from '../../../../../components/controls/CuentaCertificadoApremioGrid';
import DebitosAutomaticosGrid from '../../../../../components/controls/DebitosAutomaticosGrid';
import DeclaracionesJuradasTab from './DeclaracionesJuradasTab';
import InspeccionesGrid from '../../../../../components/controls/InspeccionesGrid';
import MultasGrid from '../../../../../components/controls/MultasGrid';
import RecargosDescuentosGrid from '../../../../../components/controls/RecargosDescuentosGrid';
import VariablesGrid from '../../../../../components/controls/VariablesGrid';
import CuentaRecibosGrid from '../../../../../components/controls/CuentaRecibosGrid';
import { OPERATION_MODE } from '@laramie/ui';
import CertificadosGrid from '../../../../../components/controls/CertificadosGrid';
import CartelesGrid from '../../../../../components/controls/CartelGrid';
import { usePermissions } from '../../../../../components/hooks/usePermissions';
import { PERMISSIONS } from '../../../../../consts/permissions';
import RetencionesGrid from '../../../../../components/controls/RetencionesGrid';

const TabsForm = ({ state, SetTabActive, UpdateEntity, pendingChange, refetchComercio }) => {
    const { hasPermission } = usePermissions();
    const canViewDebitosAutomaticos = hasPermission(PERMISSIONS.DEBITOS_AUTOMATICOS_VIEW);
    const canEditDebitosAutomaticos = hasPermission(PERMISSIONS.DEBITOS_AUTOMATICOS_EDIT);
    const canEditEximiciones = hasPermission(PERMISSIONS.EXIMICIONES_EDIT);
    const canEditCondicionesEspeciales = hasPermission(PERMISSIONS.CONDICION_ESPECIAL_EDIT);
    const canEditCertificados = hasPermission(PERMISSIONS.CERTIFICADOS_EDIT);

    return (
        <Tabs
            id="tabs-comercio"
            activeKey={state.tabActive}
            className="m-top-20"
            onSelect={(tab) => SetTabActive(tab)}
        >
            <Tab eventKey="declaracionesJuradas" title="Declaraciones juradas">
                <DeclaracionesJuradasTab
                    state={state}
                    UpdateEntity={UpdateEntity}
                />
            </Tab>
            <Tab eventKey="retenciones" title="Retenciones">
                <div className='tab-panel'>
                    <RetencionesGrid
                        processKey={state.processKey}
                        disabled={state.mode === OPERATION_MODE.VIEW}
                        data={{
                            idCuenta: state.entity.cuenta.id,
                            list: state.entity.retenciones
                        }}
                    />
                </div>
            </Tab>
            <Tab eventKey="carteles" title="Carteles">
                <div className='tab-panel'>
                    <CartelesGrid
                        processKey={state.processKey}
                        disabled={state.mode === OPERATION_MODE.VIEW}
                        data={{
                            idComercio: state.entity.comercio.id,
                            list: state.entity.carteles
                        }}
                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                    />
                </div>
            </Tab>
            <Tab eventKey="inspecciones" title="Inspecciones">
                <div className='tab-panel'>
                    <InspeccionesGrid
                        processKey={state.processKey}
                        disabled={state.mode === OPERATION_MODE.VIEW}
                        data={{
                            idComercio: state.entity.comercio.id,
                            list: state.entity.inspecciones
                        }}
                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                    />
                </div>
            </Tab>
            <Tab eventKey="multas" title="Multas">
                <div className='tab-panel'>
                    <MultasGrid
                        processKey={state.processKey}
                        disabled={state.mode === OPERATION_MODE.VIEW}
                        data={{
                            idCuenta: state.entity.cuenta.id,
                            idTipoTributo: state.entity.cuenta.idTipoTributo,
                            list: state.entity.multas
                        }}
                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                    />
                </div>
            </Tab>
            <Tab eventKey="exenciones" title="Recargos-Descuentos">
                <div className='tab-panel'>
                    <RecargosDescuentosGrid
                        processKey={state.processKey}
                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditEximiciones}
                        data={{
                            idCuenta: state.entity.cuenta.id,
                            idTipoTributo: state.entity.cuenta.idTipoTributo,
                            personas: state.entity.vinculosComercio,
                            list: state.entity.recargosDescuentos
                        }}
                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                    />
                </div>
            </Tab>
            <Tab eventKey="condiciones" title="Condiciones especiales">
                <div className='tab-panel'>
                    <CondicionesEspecialesGrid
                        processKey={state.processKey}
                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditCondicionesEspeciales}
                        data={{
                            idCuenta: state.entity.cuenta.id,
                            idTipoTributo: state.entity.cuenta.idTipoTributo,
                            list: state.entity.condicionesEspeciales
                        }}
                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                    />
                </div>
            </Tab>
            <Tab eventKey="debitos" title="Débitos automáticos"
                 tabClassName={canViewDebitosAutomaticos ? '' : 'invisible'}>
                <div className='tab-panel'>
                    <DebitosAutomaticosGrid
                        processKey={state.processKey}
                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditDebitosAutomaticos}
                        data={{
                            idCuenta: state.entity.cuenta.id,
                            list: state.entity.debitosAutomaticos
                        }}
                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                    />
                </div>
            </Tab>
            <Tab eventKey="legal" title="Información legal">
                <div className='tab-panel'>
                    <CuentaCertificadoApremioGrid
                        data={{
                            idCuenta: state.entity.cuenta.id
                        }}
                    />
                </div>
            </Tab>
            <Tab eventKey="variables" title="Variables">
                <div className='tab-panel'>
                    <VariablesGrid
                        disabled={state.mode === OPERATION_MODE.VIEW}
                        data={{
                            idTipoTributo: state.entity.cuenta.idTipoTributo,
                            idCuenta: state.entity.cuenta.id,
                            listVariableCuenta: state.entity.variablesCuenta
                        }}
                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                    />
                </div>
            </Tab>
            <Tab eventKey="recibos" title="VEPs">
                <div className='tab-panel'>
                    <CuentaRecibosGrid
                        processKey={state.processKey}
                        data={{
                            idCuenta: state.entity.cuenta.id
                        }}
                    />
                </div>
            </Tab>
            <Tab eventKey="certificados" title="Certificados">
                <div className='tab-panel'>
                    <CertificadosGrid
                        disabled={!canEditCertificados}
                        entity={state.entity}
                        pendingChange={pendingChange}
                        onCertificadoAdded={refetchComercio}
                    />
                </div>
            </Tab>
        </Tabs>
    )
}

export default TabsForm
